module.exports = __webpack_public_path__ + "img/spin_btn.12c14e21.png";